import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styles from './GetToKnow.module.sass';
import Button from '../../../ui_kit/button/Button';
import BackButton from '../back_button/BackButton';
import AboutForm from './about_form/AboutForm';
import { aboutFormValuesSelector, aboutFormInvalidSelector } from '../../selectors/about';

function GetToKnow(props) {
  const {
    finishQuiz, decreaseStep, quiz, step, aboutFormValues, aboutFormInvalid, loading,
  } = props;

  const [files, setFiles] = useState(quiz.files);

  return (
    <>
      <BackButton
        decreaseStep={() => { decreaseStep({ ...quiz, ...aboutFormValues, files }); }}
      />
      <div className={styles['get-to-know']}>
        <div className={styles.content}>
          {step}
          { !step && <div className={styles['top-spacing']} />}
          <h1 className={styles.title}>
            { quiz.concerns.length > 0 && 'Now that we know your innovation, we want to get to know you!' }
            { quiz.concerns.length === 0 && 'Tell us more about you and your innovation!'}
          </h1>
          <AboutForm
            initialValues={quiz}
            files={files}
            setFiles={setFiles}
            concerns={quiz.concerns}
            solvingProblems={quiz.solvingProblems}
          />
          <Button
            className={`${styles.button} custom-transparent-button ${loading && 'loading'}`}
            onClickHandler={() => { finishQuiz({ ...quiz, ...aboutFormValues, files }); }}
            text="DONE"
            disabled={aboutFormInvalid}
            loading={loading}
            color="transparent-blue"
            size="small"
          />
        </div>
      </div>
    </>
  );
}

GetToKnow.propTypes = {
  finishQuiz: PropTypes.func.isRequired,
  decreaseStep: PropTypes.func.isRequired,
  quiz: PropTypes.shape({
    files: PropTypes.arrayOf(PropTypes.shape({})),
    concerns: PropTypes.arrayOf(PropTypes.string),
    solvingProblems: PropTypes.string,
  }).isRequired,
  step: PropTypes.node,
  aboutFormValues: PropTypes.shape({}),
  aboutFormInvalid: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  aboutFormValues: aboutFormValuesSelector(state),
  aboutFormInvalid: aboutFormInvalidSelector(state),
});

export default connect(mapStateToProps)(GetToKnow);
